export const API_CACHE_KEYS = {
    USER_FREE_TRIAL_ELIGIBILITY_CACHE_KEY: 'userFreeTrialEligibility',
};
export const CACHE_KEYS_TO_INVALIDATE_ON_LOGOUT = [API_CACHE_KEYS.USER_FREE_TRIAL_ELIGIBILITY_CACHE_KEY];
